import { Flex } from '../../../summary/components/Flex.js';
import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.js';
import { sumPercentWidths } from '../utils/sumPercentWidths.js';

export const CostApproachSummaryRollupRow = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <>
    <Tr borderTop="1px solid black">
      <Td width={COST_APPROACH_COLUMN_WIDTHS[0]} isFirstColumn={true}>
        <Typography variant="h4">{label}</Typography>
      </Td>
      <Td colSpan={7} width={sumPercentWidths(...COST_APPROACH_COLUMN_WIDTHS.slice(1, 4))}>
        <Flex justifyContent="flex-end">
          <Typography variant="h4" textAlign="right">
            {value}
          </Typography>
        </Flex>
      </Td>
    </Tr>
  </>
);
